import { ENV } from '../../../config/runtimeEnv';
import { BloodTest } from "../../../types/lab/BloodTestTypes";
import { flattenBloodTestResults, bloodTestFromOrder } from "../../../utils/geneCodes/bloodTestShape";
import type { UserUuid } from "../../../types/identity";
import { http } from "../../../lib/http/client";

// Re-exported so existing importers keep working; the implementations are pure and live
// outside this module, which reads `import.meta.env` at load.
export { flattenBloodTestResults, bloodTestFromOrder };

const HEALTHCARE_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

export const fetchPatientBloodTests = async (patientId: UserUuid): Promise<BloodTest[]> => {
	const response = await http.get(`${HEALTHCARE_BASE_URL}/patients/${patientId}/blood-tests`);
	const bloodTests: BloodTest[] = response.data.data ?? response.data;
	return bloodTests.map(flattenBloodTestResults);
};

export const fetchBloodTest = async (id: number): Promise<BloodTest> => {
	const response = await http.get(`${HEALTHCARE_BASE_URL}/blood-tests/${id}`);
	return flattenBloodTestResults(response.data.data ?? response.data);
};

export const reanalyzeBloodTest = async (id: number): Promise<{ message: string }> => {
	const response = await http.post(`${HEALTHCARE_BASE_URL}/blood-tests/${id}/reanalyze`, {});
	return response.data;
};
